import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .rule {
      display: flex;
      align-items: center;
      line-height: 1.125;

      .icon {
        margin-right: 0.5rem;
        font-size: 1rem;

        transition: all 0.3s ease-in-out;

        &.success {
          color: ${theme.colors.success};
        }
        &.error {
          color: ${theme.colors.warning};
        }
      }
    }
  `}
`
